import { Controller } from "@hotwired/stimulus"
import DataTable from "datatables.net"
import "datatables.net-columncontrol-dt";
import "datatables.net-datetime";
import moment from "moment";

export default class extends Controller {
  static targets = ["table"];
  static values = { url: String }
  connect() {
    window.moment = moment;

    if (this.table) return
    if (this.element.classList.contains('dataTable')) return

    this.table = new DataTable(this.tableTarget, {
      serverSide: true,
      order: [[6, 'desc']],
      paging: true,
      columns: [
        { data: 'readable_id', className: 'dt-control' },
        { data: 'title' },
        { data: 'status' },
        { data: 'author_name' },
        { data: 'assignee_name' },
        { data: 'created_at' },
        { data: 'updated_at' }
      ],
      columnDefs: [
        {
          targets: 0,
          className: "border dt-body-left text-nowrap"
        },
        {
          targets: 1,
          className: "border",
          columnControl: {
            target: 0,
            content: ['order', ['orderAsc', 'orderDesc', 'search']]
          }
        },
        {
          targets: 2,
          className: "border text-center",
          columnControl: [[{ extend: 'searchList', ajaxOnly: true }]]
        },
        {
          targets: 3,
          className: "border text-center",
          orderable: false,
          columnControl: {
            target: 0,
            content: [[{ extend: 'searchList', ajaxOnly: true }]]
          }
        },
        {
          targets: 4,
          className: "border text-center",
          columnControl: {
            target: 0,
            content: [[{ extend: 'searchList', ajaxOnly: true }]]
          }
        },
        {
          targets: 5,
          className: "border text-center dt-body-center",
          render: DataTable.render.datetime('YYYY-MM-DD HH:mm:ss ZZ','DD.MM.YYYY', 'ru'),
          columnControl: {
            target: 0,
            content: [['searchDateTime']]
          }
        },
        {
          targets: 6,
          className: "border text-gray-500 text-xs text-nowrap",
          render: DataTable.render.datetime('YYYY-MM-DD HH:mm:ss ZZ','DD.MM.YYYY HH:mm:ss', 'ru'),
          searchable: false
        }
      ],
      columnControl: true,
      ajax: this.urlValue,
      responsive: true,
      pageLength: 10,
      createdRow: function(row, data, dataIndex) {
        row.classList.add('no-color');
      },
      language: {
        "processing": "Подождите...",
        "search": "Поиск:",
        "lengthMenu": "Показать _MENU_ записей",
        "info": "Записи с _START_ до _END_ из _TOTAL_ записей",
        "infoEmpty": "Записи с 0 до 0 из 0 записей",
        "infoFiltered": "(отфильтровано из _MAX_ записей)",
        "loadingRecords": "Загрузка записей...",
        "zeroRecords": "Записи отсутствуют.",
        "emptyTable": "В таблице отсутствуют данные",
        "paginate": {
          "first": "«",
          "previous": "<",
          "next": ">",
          "last": "»"
        },
        "aria": {
          "sortAscending": ": активировать для сортировки столбца по возрастанию",
          "sortDescending": ": активировать для сортировки столбца по убыванию"
        },
        "select": {
          "rows": {
            "_": "Выбрано записей: %d",
            "1": "Выбрана одна запись"
          },
          "cells": {
            "_": "Выбрано %d ячеек",
            "1": "Выбрана 1 ячейка "
          },
          "columns": {
            "1": "Выбран 1 столбец ",
            "_": "Выбрано %d столбцов "
          }
        },
        "columnControl": {
          "orderAsc": 'По возрастанию',
          "orderDesc": 'По убыванию',
          "search": {
            "text": {
              "starts": "Начинается с",
              "contains": "Содержит",
              "empty": "Пусто",
              "ends": "Заканчивается на",
              "equal": "Равно",
              "notEqual": "Не равно",
              "notEmpty": "Не пусто",
              "notContains": "Не содержит"
            }
          }
        },
        "searchBuilder": {
          "conditions": {
            "string": {
              "startsWith": "Начинается с",
              "contains": "Содержит",
              "empty": "Пусто",
              "endsWith": "Заканчивается на",
              "equals": "Равно",
              "not": "Не",
              "notEmpty": "Не пусто",
              "notContains": "Не содержит",
              "notStartsWith": "Не начинается на",
              "notEndsWith": "Не заканчивается на"
            },
            "date": {
              "after": "После",
              "before": "До",
              "between": "Между",
              "empty": "Пусто",
              "equals": "Равно",
              "not": "Не",
              "notBetween": "Не между",
              "notEmpty": "Не пусто"
            },
            "number": {
              "empty": "Пусто",
              "equals": "Равно",
              "gt": "Больше чем",
              "gte": "Больше, чем равно",
              "lt": "Меньше чем",
              "lte": "Меньше, чем равно",
              "not": "Не",
              "notEmpty": "Не пусто",
              "between": "Между",
              "notBetween": "Не между ними"
            },
            "array": {
              "equals": "Равно",
              "empty": "Пусто",
              "contains": "Содержит",
              "not": "Не равно",
              "notEmpty": "Не пусто",
              "without": "Без"
            }
          },
          "data": "Данные",
          "deleteTitle": "Удалить условие фильтрации",
          "logicAnd": "И",
          "logicOr": "Или",
          "title": {
            "0": "Конструктор поиска",
            "_": "Конструктор поиска (%d)"
          },
          "value": "Значение",
          "add": "Добавить условие",
          "button": {
            "0": "Конструктор поиска",
            "_": "Конструктор поиска (%d)"
          },
          "clearAll": "Очистить всё",
          "condition": "Условие",
          "leftTitle": "Превосходные критерии",
          "rightTitle": "Критерии отступа"
        },
        "searchPanes": {
          "clearMessage": "Очистить всё",
          "collapse": {
            "0": "Панели поиска",
            "_": "Панели поиска (%d)"
          },
          "count": "{total}",
          "countFiltered": "{shown} ({total})",
          "emptyPanes": "Нет панелей поиска",
          "loadMessage": "Загрузка панелей поиска",
          "title": "Фильтры активны - %d",
          "showMessage": "Показать все",
          "collapseMessage": "Скрыть все"
        },
        "buttons": {
          "pdf": "PDF",
          "print": "Печать",
          "collection": "Коллекция ▼",
          "colvis": "Видимость столбцов",
          "colvisRestore": "Восстановить видимость",
          "copy": "Копировать",
          "copyKeys": "Нажмите ctrl or u2318 + C, чтобы скопировать данные таблицы в буфер обмена.  Для отмены, щелкните по сообщению или нажмите escape.",
          "copyTitle": "Скопировать в буфер обмена",
          "csv": "CSV",
          "excel": "Excel",
          "pageLength": {
            "-1": "Показать все строки",
            "_": "Показать %d строк",
            "1": "Показать 1 строку"
          },
          "removeState": "Удалить",
          "renameState": "Переименовать",
          "copySuccess": {
            "1": "Строка скопирована в буфер обмена",
            "_": "Скопировано %d строк в буфер обмена"
          },
          "createState": "Создать состояние",
          "removeAllStates": "Удалить все состояния",
          "savedStates": "Сохраненные состояния",
          "stateRestore": "Состояние %d",
          "updateState": "Обновить"
        },
        "decimal": ".",
        "infoThousands": ",",
        "autoFill": {
          "cancel": "Отменить",
          "fill": "Заполнить все ячейки %d",
          "fillHorizontal": "Заполнить ячейки по горизонтали",
          "fillVertical": "Заполнить ячейки по вертикали",
          "info": "Информация"
        },
        "datetime": {
          "previous": "Предыдущий",
          "next": "Следующий",
          "hours": "Часы",
          "minutes": "Минуты",
          "seconds": "Секунды",
          "unknown": "Неизвестный",
          "amPm": [
            "AM",
            "PM"
          ],
          "months": {
            "0": "Январь",
            "1": "Февраль",
            "10": "Ноябрь",
            "11": "Декабрь",
            "2": "Март",
            "3": "Апрель",
            "4": "Май",
            "5": "Июнь",
            "6": "Июль",
            "7": "Август",
            "8": "Сентябрь",
            "9": "Октябрь"
          },
          "weekdays": [
            "Вс",
            "Пн",
            "Вт",
            "Ср",
            "Чт",
            "Пт",
            "Сб"
          ]
        },
        "editor": {
          "close": "Закрыть",
          "create": {
            "button": "Новый",
            "title": "Создать новую запись",
            "submit": "Создать"
          },
          "edit": {
            "button": "Изменить",
            "title": "Изменить запись",
            "submit": "Изменить"
          },
          "remove": {
            "button": "Удалить",
            "title": "Удалить",
            "submit": "Удалить",
            "confirm": {
              "_": "Вы точно хотите удалить %d строк?",
              "1": "Вы точно хотите удалить 1 строку?"
            }
          },
          "multi": {
            "restore": "Отменить изменения",
            "title": "Несколько значений",
            "noMulti": "Это поле должно редактироватся отдельно, а не как часть групы",
            "info": "Выбранные элементы содержат разные значения для этого входа.  Чтобы отредактировать и установить для всех элементов этого ввода одинаковое значение, нажмите или коснитесь здесь, в противном случае они сохранят свои индивидуальные значения."
          },
          "error": {
            "system": "Возникла системная ошибка"
          }
        },
        "searchPlaceholder": "Что ищете?",
        "stateRestore": {
          "creationModal": {
            "button": "Создать",
            "search": "Поиск",
            "columns": {
              "search": "Поиск по столбцам",
              "visible": "Видимость столбцов"
            },
            "name": "Имя:",
            "order": "Сортировка",
            "paging": "Страницы",
            "scroller": "Позиция прокрутки",
            "searchBuilder": "Редактор поиска",
            "select": "Выделение",
            "title": "Создать новое состояние",
            "toggleLabel": "Включает:"
          },
          "removeJoiner": "и",
          "removeSubmit": "Удалить",
          "renameButton": "Переименовать",
          "duplicateError": "Состояние с таким именем уже существует.",
          "emptyError": "Имя не может быть пустым.",
          "emptyStates": "Нет сохраненных состояний",
          "removeConfirm": "Вы уверены, что хотите удалить %s?",
          "removeError": "Не удалось удалить состояние.",
          "removeTitle": "Удалить состояние",
          "renameLabel": "Новое имя для %s:",
          "renameTitle": "Переименовать состояние"
        },
        "thousands": " "
      }
    })

    this.tableTarget.addEventListener('click', (e) => {
      if (e.target.classList.contains('dt-control')) {
        this.toggleRow(e)
      }
    })

  }

  disconnect() {
    if (this.table) {
      this.table.destroy();
      this.table = null
    }
  }

  toggleRow(e) {
    const tr = e.target.closest('tr')
    const row = this.table.row(tr)

    if (row.child.isShown()) {
      row.child.hide()
      tr.classList.remove('shown')
    } else {
      row.child(this.format(row.data())).show()
      tr.classList.add('shown')
    }
  }

  format(d) {
    return `
      <div class="p-3 bg-light">
        Full name: ${d.readable_id}<br>
        Extra info: ${d.type}
      </div>
    `
  }
}